export const DEBOUNCE_TIME = 500;

export const enum ANREDE {
    HERR,
    FRAU,
}
export const enum ANLASSAUSWAHL {
    PRODUKTBEZOGEN,
    ANLASSBEZOGEN,
    KOMPLETT,
}
export const enum ANLASSOPTION {
    HAUSRAT,
    HAFTPFLICHT,
    RECHTSSCHUTZ,
    WOHNGEBAEUDE,
    UNFALL,
    KFZ,
    RENTENVERSICHERUNG,
    LEBENSVERSICHERUNG,
    BU,
    EU,
    GRUNDFAEHIGKEIT,
    RISIKOLEBENSVERSICHERUNG,
    VOLLEKV,
    KHT,
    KRANKENZUSATZ,
    ZAHNZUSATZ,
    HEIRAT,
    SCHEIDUNG,
    NACHWUCHS,
    UMZUG,
    URLAUB,
    IMMOBILIENERWERB,
    RUNDUMSKFZ,
    WUENSCHEUNDZIELE,
}

export interface Value {
    modelValue: number;
    viewValue: string;
}
export /*const*/ enum CustomerType {
    INDIVIDUAL,
    COMPANY,
}
export class EnumDescriptor {
    Store: string;
    Human: string;
}
export class Strings {
    public static CustomerDesc(key: CustomerType): EnumDescriptor {
        const lut = {};
        lut[CustomerType.INDIVIDUAL] = {
            Store: "#com.zurich.zbd.data.model.Individual",
            Human: "Individual",
        };
        lut[CustomerType.COMPANY] = {
            Store: "#com.zurich.zbd.data.model.Company",
            Human: "Unternehmen",
        };
        return lut[key];
    }
    public static CustomerTypeFromClass(className: string): CustomerType {
        return {
            "#com.zurich.zbd.data.model.Individual": CustomerType.INDIVIDUAL,
            "#com.zurich.zbd.data.model.Company": CustomerType.COMPANY,
        }[className];
    }
    public static CustomerDescFromClass(className: string): EnumDescriptor {
        return this.CustomerDesc(this.CustomerTypeFromClass(className));
    }

    public static Herr: Value = {
        modelValue: ANREDE.HERR,
        viewValue: "Herr",
    };
    public static Frau: Value = {
        modelValue: ANREDE.FRAU,
        viewValue: "Frau",
    };

    public static Produktbezogen: Value = {
        modelValue: ANLASSAUSWAHL.PRODUKTBEZOGEN,
        viewValue: "Produktberatung",
    };
    public static Anlassbezogen: Value = {
        modelValue: ANLASSAUSWAHL.ANLASSBEZOGEN,
        viewValue: "Anlassberatung",
    };
    public static Komplett: Value = {
        modelValue: ANLASSAUSWAHL.KOMPLETT,
        viewValue: "Globalberatung",
    };

    public static Hausrat: Value = {
        modelValue: ANLASSOPTION.HAUSRAT,
        viewValue: "Hausrat",
    };
    public static Haftpflicht: Value = {
        modelValue: ANLASSOPTION.HAFTPFLICHT,
        viewValue: "Haftpflicht",
    };
    public static Rechtsschutz: Value = {
        modelValue: ANLASSOPTION.RECHTSSCHUTZ,
        viewValue: "Rechtsschutz",
    };
    public static Wohngebaeude: Value = {
        modelValue: ANLASSOPTION.WOHNGEBAEUDE,
        viewValue: "Wohngebäude",
    };
    public static Unfall: Value = {
        modelValue: ANLASSOPTION.UNFALL,
        viewValue: "Unfall",
    };
    public static KFZ: Value = {
        modelValue: ANLASSOPTION.KFZ,
        viewValue: "KFZ",
    };
    public static Rentenversicherung: Value = {
        modelValue: ANLASSOPTION.RENTENVERSICHERUNG,
        viewValue: "Rentenversicherung",
    };
    public static Lebensversicherung: Value = {
        modelValue: ANLASSOPTION.LEBENSVERSICHERUNG,
        viewValue: "Lebensversicherung",
    };
    public static BU: Value = {
        modelValue: ANLASSOPTION.BU,
        viewValue: "BU",
    };
    public static EU: Value = {
        modelValue: ANLASSOPTION.EU,
        viewValue: "EU",
    };
    public static Grundfaehigkeit: Value = {
        modelValue: ANLASSOPTION.GRUNDFAEHIGKEIT,
        viewValue: "Grundfähigkeit",
    };
    public static Risikolebensversicherung: Value = {
        modelValue: ANLASSOPTION.RISIKOLEBENSVERSICHERUNG,
        viewValue: "Risiko-Lebensversicherung",
    };
    public static VolleKV: Value = {
        modelValue: ANLASSOPTION.VOLLEKV,
        viewValue: "Volle KV",
    };
    public static KHT: Value = {
        modelValue: ANLASSOPTION.KHT,
        viewValue: "KHT",
    };
    public static Krankenzusatz: Value = {
        modelValue: ANLASSOPTION.KRANKENZUSATZ,
        viewValue: "Krankenzusatz",
    };
    public static Zahnzusatz: Value = {
        modelValue: ANLASSOPTION.ZAHNZUSATZ,
        viewValue: "Zahnzusatz",
    };
    public static Heirat: Value = {
        modelValue: ANLASSOPTION.HEIRAT,
        viewValue: "Heirat",
    };
    public static Scheidung: Value = {
        modelValue: ANLASSOPTION.SCHEIDUNG,
        viewValue: "Scheidung",
    };
    public static Nachwuchs: Value = {
        modelValue: ANLASSOPTION.NACHWUCHS,
        viewValue: "Nachwuchs",
    };
    public static Umzug: Value = {
        modelValue: ANLASSOPTION.UMZUG,
        viewValue: "Umzug",
    };
    public static Urlaub: Value = {
        modelValue: ANLASSOPTION.URLAUB,
        viewValue: "Urlaub",
    };
    public static Immobilienerwerb: Value = {
        modelValue: ANLASSOPTION.IMMOBILIENERWERB,
        viewValue: "Immobilienerwerb",
    };
    public static RundUmsKFZ: Value = {
        modelValue: ANLASSOPTION.RUNDUMSKFZ,
        viewValue: "Rund ums KFZ",
    };
    public static WuenscheUndZiele: Value = {
        modelValue: ANLASSOPTION.WUENSCHEUNDZIELE,
        viewValue: "Wünsche und Ziele",
    };

    public static TrackingInfoText =
        "Achtung, bei manuellem Eingriff wird ein eventuell noch nicht abgeschlossenes Tracking für dieses Feld ausgesetzt.";

    public static Document = {
        Creating: "Das Dokument wird erstellt ...",
        FetchingMeta: "Metadaten werden abgerufen ...",
        FetchingPdf: "Das Dokument wird abgerufen ...",
        ViewErrorInfo:
            'Es ist ein Fehler aufgetreten, der verhindert dass der Vorgang abgeschlossen werden kann. Für den Fall, dass es sich um ein vorrübergehendes Problem handelt, können Sie dieses Dokument erneut erstellen, indem Sie den Reiter "Dokumentenvorschau" zu- und wieder aufklappen.',
        EmailErrorInfo:
            'Es ist ein Fehler aufgetreten, der verhindert dass der Vorgang abgeschlossen werden kann. Für den Fall, dass es sich um ein vorrübergehendes Problem handelt, können Sie dieses Dokument erneut senden, indem Sie den Button "Senden" wieder benutzen.',
        GenericError: "Das Dokument konnte nicht erstellt werden.",
        NoPdfError: "Das Dokument konnte nicht geladen werden.",
        SignError: "Die Unterschriften konnten nicht gespeichert werden.",
        EmailError: "Das Dokument konnte nicht gesendet werden.",
    };

    public static profileHandedGeneric =
        "Das Vermittlerprofil wurde anlässlich der Beratung ausgehändigt bzw. lag bereits vor";
    public static profileHandedMakler =
        "Es liegt eine gültige Maklervollmacht vor.";
}
